var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLink',{staticClass:"navbar-brand mr-1",attrs:{"to":"/"}},[_c('canvas',{attrs:{"id":"brand-canvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }